import { useMediaQuery } from '@mui/material';
import { MAX_WITH_MOBILE_MEDIA } from '../config/getTheme';

const useIsMobile = () => {
  return useMediaQuery(MAX_WITH_MOBILE_MEDIA);
};

export default useIsMobile;
